import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import SvgIcon from "@/components/common/SvgIcon";
const app = createApp(App);


//掛入GTM
import {createGtm} from 'vue-gtm';

const gtmCode = process.env.VUE_APP_GOOGLE_GTM_ID;
//console.log('gtmCode', gtmCode,process.env);
if (gtmCode) {
  app.use(createGtm({
    id: gtmCode,
    debug: true,
    vueRouter: router,
    trackOnNextTick: false,
  }));
}

//使用element-plus plugin
// import {elComponents} from "@/plugins/element-plus.config.js";
//
// elComponents.forEach((component) => {
//   app.component(component.name, component);
// });

//使用vue-cookies
import VueCookies from "vue-cookies";
app.use(VueCookies);
app.$cookies.config("1d", "/", `${process.env.VUE_APP_COOKIES_DOMAIN}`);

// 定期執行請求的計時器
import { ReTokenApi } from "@/apis/userApi";
const timerIntervalMinutes = 1; // 設定計時器間隔時間（單位：分鐘）
setInterval(() => {
  // 在這裡執行您希望在每分鐘觸發的操作
  //取得目前登入的TOKEN時間

  const currentUnixTimeInSeconds = Math.floor(new Date().getTime() / 1000);
  let isLogin = sessionStorage.getItem("isLogin");
  let loginCsrf = sessionStorage.getItem("loginCsrf");
  let tokenTime = sessionStorage.getItem("tokenTime");

  if (isLogin == 1 && tokenTime - currentUnixTimeInSeconds <= 300) {
    console.log("進行RETOKEN");
    ReTokenApi({ csrf: loginCsrf }).then((res) => {
      console.log(res);
      if (res.data.token) {
        sessionStorage.setItem("accessToken", res.data.token);
        sessionStorage.setItem("tokenTime", res.data.unixtime);
        sessionStorage.setItem("loginCsrf", res.data.csrf);
        app.$cookies.set("accessToken", res.data.token);
      }
    });
  }
  console.log("執行請求或其他操作...", currentUnixTimeInSeconds, isLogin);
  console.log("差異秒數", tokenTime - currentUnixTimeInSeconds);
}, timerIntervalMinutes * 60 * 1000); // 將分鐘轉換為毫秒

// lottiefiles
import lottie from "vue-lottie";

// animate.css
import "animate.css";
import "animate.css/animate.compat.css";

/* import google font */
import { loadFonts } from "./plugins/webfontloader";

/* import the fontawesome core */
import { library } from "@fortawesome/fontawesome-svg-core";

/* import font awesome icon component */
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

/* import specific icons */
import {
  faInstagram,
  faFacebook,
  faLine,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";

/* add icons to the library */
library.add(faInstagram, faFacebook, faLine, faYoutube);
/* import svg */
const requireAll = (requireContext) =>
  requireContext.keys().map(requireContext);
const req = require.context("../src/assets/icons", true, /\.svg$/);
requireAll(req);

// Import our custom CSS
import "../src/assets/scss/common.scss";

loadFonts();

const pinia = createPinia();

//全域使用‘千分位’
import { numberToCurrencyString as currency } from "@/utilities/numberToCurrencyString";
//參考：https://ithelp.ithome.com.tw/articles/10282483?sc=rss.qu
app.config.globalProperties.$filters = {
  //轉千分位數
  currency,
};

//使用element-plus plugin
import { elComponents } from "@/plugins/element-plus.config.js";
elComponents.forEach((component) => {
  app.component(component.name, component);
});

app
  .component("lottie", lottie)
  .use(router)
  .use(pinia)
  .component("font-awesome-icon", FontAwesomeIcon)
  .component("icon", SvgIcon)
  .mount("#app");
